import { render, staticRenderFns } from "./mention-option.vue?vue&type=template&id=4f81272f&"
import script from "./mention-option.vue?vue&type=script&lang=js&"
export * from "./mention-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports